var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0216 20.2803C15.3121 20.2803 19.6008 15.9918 19.6008 10.7017C19.6008 5.41154 15.3121 1.12305 10.0216 1.12305C4.7312 1.12305 0.442459 5.41154 0.442459 10.7017C0.442459 15.9918 4.7312 20.2803 10.0216 20.2803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0214 1.45724C15.1104 1.45724 19.2484 5.59506 19.2484 10.6837C19.2484 15.7723 15.1104 19.9101 10.0214 19.9101C4.93251 19.9101 0.776838 15.7899 0.776838 10.7013C0.776838 5.59506 4.93251 1.45724 10.0214 1.45724ZM10.0214 0.75293C4.52751 0.75293 0.0724869 5.20769 0.0724869 10.7013C0.0724869 16.1949 4.52751 20.6321 10.0038 20.6321C15.4978 20.6321 19.9352 16.1773 19.9352 10.7013C19.9528 5.20769 15.4978 0.75293 10.0214 0.75293Z",
    fill: "#00AFE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3003 6.33447C14.2651 6.33447 14.2299 6.33447 14.1771 6.35208L4.1929 10.1554C3.91116 10.261 3.91116 10.666 4.21051 10.754L6.51726 11.5464L7.90836 14.346C7.92597 14.3988 7.97879 14.434 8.04923 14.434C8.08444 14.434 8.11966 14.4164 8.13727 14.3988L9.44032 13.2895L7.97879 12.1802L8.10205 13.6417L7.04553 11.4583L12.6451 8.09525L7.9964 12.1802L11.6238 14.9271C11.7471 15.0151 11.8879 15.0679 12.0288 15.0679C12.3106 15.0679 12.5923 14.8742 12.6627 14.5749L14.6173 6.73945C14.6701 6.52816 14.494 6.33447 14.3003 6.33447Z",
    fill: "#00AFE5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.99,
    height: 20.02,
    fill: "white",
    transform: "translate(0 0.700195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram2);
export default __webpack_public_path__ + "static/media/telegram-2.78dd556e2f8138fce0fd6d53900f450c.svg";
export { ForwardRef as ReactComponent };